module.exports = __webpack_public_path__ + "static/img/lqt_bg.14ff2dc9.png";